import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";
import { card32Players } from "../videoBox/overlays/card32Cards";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

/**
 * Reference result body for 32 Cards (bootstrap-vue result modal, types card32 / pcard32 / tcard32 / card32eu):
 * .row.row5.card32result > .col-12.col-lg-8 (Player 8..11 blocks with cards, count badge, trophy for the winner)
 * + .col-12.col-lg-4 .casino-result-desc (Winner; card32eu adds Odd/Even, Black/Red, Total, Single from rdesc).
 */
export default function Card32ResultBody({ t1, gameType = "card32" }) {
  const players = card32Players(t1?.card);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const oddEven = String(desc[1] ?? "").split("~");

  return (
    <div className="row row5 card32result">
      <div className="col-12 col-lg-8">
        <div className="row row5">
          {players.map((p, i) =>
            p.cards.length ? (
              <React.Fragment key={p.name}>
                {i > 0 && " "}
                <div className="col-12 col-lg-12">
                  <div className="casino-result-cards">
                    <h4 className="text-center d-inline-block">
                      {`Player ${p.name} - `}
                      <span className="badge badge-success font14">{p.count}</span>
                    </h4>{" "}
                    {p.cards.map((c, ci) => (
                      <div key={ci} className="casino-result-cards-item">
                        <img src={getCardImage(c)} />
                      </div>
                    ))}{" "}
                    {win === String(i + 1) && (
                      <div className="casino-result-cards-item">
                        <img src={WINNER_IMG} className="winner-icon" />
                      </div>
                    )}
                  </div>
                </div>
              </React.Fragment>
            ) : null
          )}
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            {gameType === "card32eu" && (
              <>
                <div className="casino-result-desc-item">
                  <div>Odd/Even</div> <div>{oddEven[0]}</div>
                </div>{" "}
                <div className="casino-result-desc-item">
                  <div /> <div>{oddEven[1]}</div>
                </div>{" "}
                <div className="casino-result-desc-item">
                  <div>Black/Red</div> <div>{desc[2]}</div>
                </div>{" "}
                <div className="casino-result-desc-item">
                  <div>Total</div> <div>{desc[3]}</div>
                </div>{" "}
                <div className="casino-result-desc-item">
                  <div>Single</div> <div>{desc[4]}</div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
